import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux";
import { StyledModalBody } from "../../../../../../components/Modals";
import { ButtonBodyVariant } from "../../../../../../components/ui/ButtonVariant";
import { useTranslation } from "react-i18next";
import { closeActiveModal } from "../../../../../../helper/modals";
import { Flex } from "../../../../../../components/ui/Flex";
import { Palette } from "../../../../../../components/utils";
import { DATE_FORMATS } from "../../../../../users/constant";
import { ModalButtonsContainer, PaymentModal, StepItem, LightBlueText, TitleText, OptionText, GridContainer, IconBackground, LoadingSpinner, closeAndClearPaymentData, ProcessingContent, BlurOverlay, ModalContainer } from "../../../../PaymentComponents";
import moment from "moment";
import { fundTransferWithdrawScheduleRequest } from "../../../../../../redux/actions/payments";
import { IoWarningOutline } from "react-icons/io5";
import { VscError } from "react-icons/vsc";
import { setToast } from "../../../../../../redux/actions/window";
import { formatMoney } from "../../../../../../utils/utils";
import { IoIosCheckmarkCircle, IoMdCheckmark } from "react-icons/io";
import { buildGrataFundTransferScheduleBody, dispatchPaymentsPageRefetch } from "../../../../PaymentUtils";

const CreateRecurringPaymentStep3 = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [testLoadingState, setTestLoadingState] = useState(0)

  const modal = useSelector((state) => state.headerModal.modal);
  const addPayment = useSelector((state) => state.addPayment);

  const confirmPayment = () => {
    setTestLoadingState(1)
    dispatch(fundTransferWithdrawScheduleRequest({
      body: buildGrataFundTransferScheduleBody({
        buildingId: addPayment.selectedBuilding.id,
        userId: addPayment.userId.value,
        amount: addPayment.amount,
        // notes: addPayment.notes,
        frequency: addPayment.frequency,
        startDate: addPayment.startDate,
        endDate: addPayment.endDate,
        // paymentCategoryId: 1
      }),
      success: () => {
        setTestLoadingState(2)
        setTimeout(() => {
          dispatchPaymentsPageRefetch();
          closeAndClearPaymentData();
        }, 2000)
      },
      fail: (err) => {
        setTestLoadingState(3)
        dispatch(
          setToast({
            toastShow: true,
            toastMessage: t('Could not charge user: {{error}}', { error: err?.data?.message }),
            modal: 'errorToast'
          })
        );
      }
    }))
  }


  return (
    <PaymentModal
      show={modal === 'CreateRecurringPaymentStep3'}
      onClose={closeActiveModal}
      closeOnBackdrop={false}
      width={'460px'}
      padding="0rem">
      <ModalContainer padding="1.5rem">
        <BlurOverlay />

        <StyledModalBody>
          <Flex direction="column" gap="1rem">
            <Flex direction="column">
              <Flex justify="space-between" alignItems="center" style={{ width: "100%" }}>
                <LightBlueText>STEP 3/3</LightBlueText>
                <Flex gap="0.5rem">
                  <StepItem filled />
                  <StepItem filled />
                  <StepItem filled />
                </Flex>
              </Flex>
              <TitleText>Confirmation</TitleText>
            </Flex>

            <Flex direction="column" gap="1rem">
              <GridContainer gap="1rem">
                <div>
                  <LightBlueText>Building</LightBlueText>
                  <OptionText>{addPayment.selectedBuilding.name}</OptionText>
                </div>

                <div>
                  <LightBlueText>Resident</LightBlueText>
                  <OptionText>{addPayment.userId.label}</OptionText>
                </div>
                <div>
                  <LightBlueText>Payment Amount</LightBlueText>
                  <OptionText>{formatMoney(addPayment.amount, addPayment.currency)}</OptionText>
                </div>

                <div>
                  <LightBlueText>Frequency</LightBlueText>
                  <OptionText>{addPayment.frequency}</OptionText>
                </div>

                <div>
                  <LightBlueText>Start Date</LightBlueText>
                  <OptionText>{moment(addPayment.startDate).format(DATE_FORMATS.MMM_DD_YYYY)}</OptionText>
                </div>

                <div>
                  <LightBlueText>End Date</LightBlueText>
                  <OptionText>{moment(addPayment.endDate).format(DATE_FORMATS.MMM_DD_YYYY)}</OptionText>
                </div>
              </GridContainer>

              <Flex direction="column" gap="1rem">
                <div>
                  <LightBlueText>Payment Type</LightBlueText>
                  <OptionText>Recurring</OptionText>
                </div>

                {/* {addPayment.notes &&
                  <div>
                    <LightBlueText>Notes</LightBlueText>
                    <OptionText>{addPayment.notes}</OptionText>
                  </div>
                } */}
              </Flex>
            </Flex>

            <ModalButtonsContainer gapY="8px">
              <ButtonBodyVariant cssOverride="width: 8.875rem; height: 2rem;" onClick={closeAndClearPaymentData}>{t('Cancel')}</ButtonBodyVariant>
              <ButtonBodyVariant variant="secondary" cssOverride="width: 8.875rem; height: 2rem;" onClick={confirmPayment}>{t('Confirm')}</ButtonBodyVariant>
            </ModalButtonsContainer>
          </Flex>

        </StyledModalBody>

        <BlurOverlay isVisible={testLoadingState !== 0}>
          <ProcessingContent>
            {testLoadingState === 1 &&
              <Flex direction="column" gap="0.75rem" alignItems="center">
                <LoadingSpinner size={38} />
                <TitleText>Authorizing recurring payment</TitleText>
              </Flex>
            }

            {testLoadingState === 2 &&
              <Flex direction="column" gap="0.75rem" alignItems="center">
                <IconBackground background={Palette.GREEN_500}>
                  <IoMdCheckmark size={32} color={Palette.WHITE} style={{ position: "absolute", right: "12px", top: "12px" }} />
                </IconBackground>
                <TitleText>Success</TitleText>
              </Flex>
            }

            {testLoadingState === 3 &&
              <Flex direction="column" gap="2.5rem" alignItems="center">
                <Flex direction="column" gap="0.75rem" alignItems="center">
                  <IconBackground background={Palette.CONTENT_NEGATIVE}>
                    <VscError size={32} color={Palette.WHITE} style={{ position: "absolute", right: "12px", top: "12px" }} />
                  </IconBackground>
                  <TitleText>Something went wrong</TitleText>
                </Flex>

                <Flex gap="0.75rem">
                  <ButtonBodyVariant cssOverride="height: 2rem; width: 7.5rem;" onClick={confirmPayment}>{t('Retry')}</ButtonBodyVariant>
                  <ButtonBodyVariant cssOverride="height: 2rem; width: 7.5rem;" variant="secondary" onClick={closeActiveModal}>{t('Cancel')}</ButtonBodyVariant>
                </Flex>
              </Flex>
            }

          </ProcessingContent>
        </BlurOverlay>
      </ModalContainer>
    </PaymentModal>
  )
}

export default CreateRecurringPaymentStep3